import permissions from '@/constants/permissions'

const SuccessCard = () => import('@/views/SuccessCard.vue')

export default [
  {
    path: '/karta-sukcesu/:childEditionId',
    name: 'SuccessCardAdd',
    component: SuccessCard,
    props: true,
    meta: {
      requireAuth: true,
      permission: [permissions.successCardAdd, permissions.assignedSuccessCardAdd]
    }
  },
  {
    path: '/karta-sukcesu/:childEditionId/:successCardId',
    name: 'SuccessCard',
    component: SuccessCard,
    props: true,
    meta: {
      requireAuth: true,
      permission: [permissions.childEditionView, permissions.assignedChildEditionView]
    }
  }
]
